<template>
  <div>
    <Sidebar />
    <assessment-questions />
  </div>
</template>

<script>
import AssessmentQuestions from '@/components/AssessmentQuestions.vue';
import Sidebar from '@/components/Sidebar.vue';

export default {
  components: {
    AssessmentQuestions,
    Sidebar
  }
};
</script> 